import { render, staticRenderFns } from "./tableModel.vue?vue&type=template&id=de2ad3a2&scoped=true&"
import script from "./tableModel.vue?vue&type=script&lang=ts&"
export * from "./tableModel.vue?vue&type=script&lang=ts&"
import style0 from "./tableModel.vue?vue&type=style&index=0&id=de2ad3a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2ad3a2",
  null
  
)

export default component.exports